export default __webpack_public_path__ + "static/media/copy.565d125c.svg";